import React, { useState, useEffect } from 'react';

const SocialIconsBackground = () => {
  // SVG图标组件
  const XIcon = ({ className }) => (
    <svg viewBox="0 0 24 24" fill="currentColor" className={className}>
      <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
    </svg>
  );

  const YouTubeIcon = ({ className }) => (
    <svg viewBox="0 0 24 24" fill="currentColor" className={className}>
      <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
    </svg>
  );

  const TikTokIcon = ({ className }) => (
    <svg viewBox="0 0 24 24" fill="currentColor" className={className}>
      <path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z"/>
    </svg>
  );

  const BilibiliIcon = ({ className }) => (
    <svg viewBox="0 0 24 24" fill="currentColor" className={className}>
      <path d="M17.813 4.653h.854c1.51.054 2.769.578 3.773 1.574 1.004.995 1.524 2.249 1.56 3.76v7.36c-.036 1.51-.556 2.769-1.56 3.773s-2.262 1.524-3.773 1.56H5.333c-1.51-.036-2.769-.556-3.773-1.56S.036 18.858 0 17.347v-7.36c.036-1.511.556-2.765 1.56-3.76 1.004-.996 2.262-1.52 3.773-1.574h.774l-1.174-1.12a1.234 1.234 0 0 1-.373-.906c0-.356.124-.658.373-.907l.027-.027c.267-.249.573-.373.92-.373.347 0 .653.124.92.373L9.653 4.44c.071.071.134.142.187.213h4.267a.836.836 0 0 1 .16-.213l2.853-2.747c.267-.249.573-.373.92-.373.347 0 .662.151.929.4.267.249.391.551.391.907 0 .356-.124.657-.373.906zM5.333 7.24c-.746.018-1.373.276-1.88.773-.506.498-.769 1.161-.789 1.987v7.36c.02.827.283 1.489.789 1.987.507.498 1.134.756 1.88.773h13.334c.746-.017 1.373-.275 1.88-.773.506-.498.769-1.16.789-1.987V9.987c-.02-.826-.283-1.489-.789-1.987-.507-.497-1.134-.755-1.88-.773zM8 11.107c.373 0 .684.124.933.373.25.249.383.569.4.96v1.173c-.017.391-.15.711-.4.96-.249.25-.56.374-.933.374s-.684-.125-.933-.374c-.25-.249-.383-.569-.4-.96V12.44c.017-.391.15-.711.4-.96.249-.249.56-.373.933-.373zm8 0c.373 0 .684.124.933.373.25.249.383.569.4.96v1.173c-.017.391-.15.711-.4.96-.249.25-.56.374-.933.374s-.684-.125-.933-.374c-.25-.249-.383-.569-.4-.96V12.44c.017-.391.15-.711.4-.96.249-.249.56-.373.933-.373z"/>
    </svg>
  );

  const InstagramIcon = ({ className }) => (
    <svg viewBox="0 0 24 24" fill="currentColor" className={className}>
      <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
    </svg>
  );

  // 随机位置状态
  const [randomIcons, setRandomIcons] = useState([]);

  // 生成随机位置和属性的函数
  const generateRandomIcon = (IconComponent, color, index) => {
    const sizes = ['w-6 h-6', 'w-8 h-8', 'w-10 h-10', 'w-12 h-12', 'w-16 h-16', 'w-20 h-20'];
    const rotations = ['rotate-0', 'rotate-12', 'rotate-45', '-rotate-12', '-rotate-30', '-rotate-45', 'rotate-90', '-rotate-90'];
    const animations = ['animate-spin', 'animate-pulse', 'animate-bounce'];
    const durations = ['10s', '15s', '20s', '25s', '30s', '35s', '40s', '45s'];
    const opacities = ['opacity-5', 'opacity-10', 'opacity-15'];
    
    return {
      id: index,
      Icon: IconComponent,
      color,
      size: sizes[Math.floor(Math.random() * sizes.length)],
      top: Math.random() * 85 + 5, // 5% to 90%
      left: Math.random() * 85 + 5, // 5% to 90%
      rotation: rotations[Math.floor(Math.random() * rotations.length)],
      animation: animations[Math.floor(Math.random() * animations.length)],
      duration: durations[Math.floor(Math.random() * durations.length)],
      opacity: opacities[Math.floor(Math.random() * opacities.length)],
      delay: Math.random() * 5, // 0-5秒延迟
    };
  };

  // 组件挂载时生成随机图标配置
  useEffect(() => {
    const iconComponents = [
      { Component: XIcon, color: 'text-gray-800' },
      { Component: YouTubeIcon, color: 'text-red-500' },
      { Component: TikTokIcon, color: 'text-gray-900' },
      { Component: BilibiliIcon, color: 'text-blue-500' },
      { Component: InstagramIcon, color: 'text-pink-500' },
    ];

    // 为每个平台生成3-5个随机图标
    const allRandomIcons = [];
    iconComponents.forEach((icon, platformIndex) => {
      const iconCount = Math.floor(Math.random() * 3) + 3; // 3-5个图标
      for (let i = 0; i < iconCount; i++) {
        allRandomIcons.push(
          generateRandomIcon(
            icon.Component, 
            icon.color, 
            platformIndex * 10 + i
          )
        );
      }
    });

    setRandomIcons(allRandomIcons);
  }, []); // 空依赖数组，只在组件挂载时运行一次

  return (
    <div className="fixed inset-0 pointer-events-none z-0 overflow-hidden">
      {randomIcons.map((iconConfig) => {
        const { 
          id, Icon, color, size, top, left, rotation, 
          animation, duration, opacity, delay 
        } = iconConfig;
        
        return (
          <div
            key={id}
            className={`absolute ${opacity} ${color} ${size} ${rotation}`}
            style={{
              top: `${top}%`,
              left: `${left}%`,
              animationDelay: `${delay}s`,
            }}
          >
            <Icon 
              className={`w-full h-full ${animation}`}
              style={{
                animationDuration: duration,
                animationIterationCount: 'infinite',
                animationTimingFunction: 'ease-in-out'
              }}
            />
          </div>
        );
      })}
    </div>
  );
};

export default SocialIconsBackground;
